import { Axios } from 'commonUtils';
import Utils from 'components/Utils';

class ConnectionApi {
  findAll = async (params = { projectId: 0, type: '', globalOnly: false }) => {
    return await Axios.getData(`/spr/connections`, { params: Utils.ObjectUtils.removeEmptyKeys(params) });
  };

  findById = async (id) => {
    const { data } = await Axios.get(`/spr/connections/${id}`);
    return data;
  };

  getDatabaseList = async () => {
    const { data } = await Axios.get('/spr/connections/databases');
    return data;
  };

  saveNewConnection = async (newConnection) => {
    const { data } = await Axios.post('/spr/connections', newConnection);
    return data;
  };

  deleteConnection = async (connectionId, connectionName = undefined) => {
    const { data } = await Axios.delete(`/spr/connections/${connectionId}`, {
      params: {
        connectionName,
      },
    });
    return data;
  };

  updateConnection = async (connection, connectionId) => {
    const { data } = await Axios.put(`/spr/connections/${connectionId}`, connection);
    return data;
  };

  testDb = async (connection) => {
    const { data } = await Axios.post('/spr/connections/test', connection);
    return data;
  };

  testDbOnBimCron = async (connection) => {
    return await Axios.post('/spr/connections/test/bim-cron', connection);
  };

  testHost = async (host, port) => {
    return await Axios.post('/spr/connections/test/host', {
      host,
      port,
    });
  };

  testHostOnBimCron = async (connection) => {
    return await Axios.post('/spr/connections/test/bim-cron/host', connection);
  };

  testInternetAccess = async () => {
    return await Axios.post('/spr/connections/test/internet-access');
  };

  fetchSchema = async ({ connectionId, inspectionType, schemaName = '', tableName = '' }) => {
    return await Axios.getData(`/spr/connections/${connectionId}/schema`, {
      params: {
        inspectionType,
        schemaName,
        tableName,
      },
    });
  };

  fetchProjectDwSchema = async (projectId) => {
    return await Axios.getData(`/spr/connections/projects/${projectId}/schema`);
  };

  findSchemaInspectionJob = async (connectionId) => {
    return await Axios.getData(`/spr/connections/${connectionId}/schema/job`);
  };

  createSchemaInspectionJob = async (connectionId) => {
    return await Axios.postData(`/spr/connections/${connectionId}/schema/job`);
  };

  clearSchemaInspectionJob = async (connectionId) => {
    await Axios.delete(`/spr/connections/${connectionId}/schema/job`);
  };
}

export default ConnectionApi;
